module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido@3x-115d29e430f922b165c26540353b5879.webp";